import React, { useEffect, useMemo, useRef, useState } from "react"
import { Form } from 'react-bootstrap'
import { useHistory } from "react-router"
import { useRecoilValue } from "recoil"
import { getStatisticsPrice, getStatisticsPriceCount, getStatisticsPriceExport } from "../../../api"
import { accountDataState } from "../../../recoil/account"
import { formatPrice } from "../../../utils"
import { useAsync } from "../../../utils/hooks"
import Loading from "../../shared/Loading"
import ReactPaginate from 'react-paginate';

interface IState {
    offset: number,
    limit: number,
    listProduct: Array<any>,
    total?: number,
    search: string,
}

const initState: IState = {
    offset: 0,
    limit: 20,
    listProduct: [],
    total: 0,
    search: '',
}

type IType = 'all' | 'rx' | 'no_rx'

const StatisticsPharmacies = React.memo(() => {
    const getStatisticsPriceAsync = useAsync(getStatisticsPrice)
    const getStatisticsPriceCountAsync = useAsync(getStatisticsPriceCount)
    const getStatisticsPriceExportAsync = useAsync(getStatisticsPriceExport)

    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN') return accountInfo.doctor.mId
    }, [accountInfo])

    const [state, setState] = useState<IState>(initState)
    const tableProduct: any = useRef()
    const inputSearch: any = useRef()
    const page: any = useRef()
    const [productType, setProductType] = useState<IType>('all');

    const backToTop = () => {
        if (!tableProduct.current?.scrollTop) return
        tableProduct.current.scrollTop = 0
    }

    const exportToCSV = async () => {
        try {
            const res = await getStatisticsPriceExportAsync.execute({ adminId, category: productType });
    
            if (!res || !res.data || res.data.length === 0) {
                alert("Không có dữ liệu để xuất!");
                return;
            }
    
            const fields = ["ID Sản phẩm", "Tên sản phẩm", "Đóng gói", ...Object.keys(res.data[0]).filter((key) =>
                key !== "m_product_id" && key !== "m_product_name" && key !== "m_pkg_name"
            )];
    
            const dataToExport = res.data.map((product: Record<string, any>) => {
                const { m_product_id, m_product_name, m_pkg_name, ...otherFields } = product;
            
                const result: Record<string, any> = {
                    "ID Sản phẩm": m_product_id,
                    "Tên sản phẩm": m_product_name,
                    "Đóng gói": m_pkg_name,
                };
            
                Object.entries(otherFields).forEach(([fieldName, value]) => {
                    result[fieldName] = value || "";
                });
            
                return result;
            });
    
            const { Parser } = await import("json2csv");
            const parser = new Parser({ fields });
            const csv = parser.parse(dataToExport);
    
            // Tạo Blob và tải file xuống
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "statistics_price.csv";
            link.click();
        } catch (error) {
            console.error("Error exporting CSV:", error);
            alert("Đã xảy ra lỗi khi xuất dữ liệu!");
        }
    };
    

    useEffect(() => {
        setState(prev => ({ ...prev, listProduct: [] }));
        backToTop()
        getStatisticsPriceAsync.execute({
            adminId,
            limit: state.limit,
            offset: state.offset,
            search: state.search,
            category: productType
        }).then(res => {
            setState(prev => ({ ...prev, listProduct: res.data }))
        })

        getStatisticsPriceCountAsync.execute({
            adminId,
            search: state.search,
            category: productType
        }).then(res => {
            setState(prev => ({ ...prev, total: res.data.total }))
        })
    }, [state?.offset, state?.limit, state?.search, adminId, productType])

    return <>
        <div id="main" style={{
            width: "100%",
            height: '100vh',
            marginTop: '1rem',
            minHeight: '-webkit-fill-available',
        }}
        >
            <div className="d-flex align-items-center justify-content-end my-3">
                <button className="btn d-flex justify-content-center align-items-center" style={{
                color: '#ff812c',
                width: '100%',
                }} onClick={exportToCSV}>
                Xuất file dữ liệu
                {getStatisticsPriceExportAsync.status === "loading" && (
                <div className="loader ml-3"></div>
                )}
                </button>
            </div>
            <div className="d-flex form-search my-3">
                <form id="search">
                    <input
                        ref={inputSearch}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              const target = e.target as HTMLInputElement;
                              setState((prev) => ({ ...prev, search: target.value }));
                            }
                        }}
                        type="text" 
                        name="search" 
                        placeholder="Tìm tên sản phẩm" 
                        className="input-search" 
                        defaultValue={state.search} />
                    <a
                        id="btn-search-clear"
                        onClick={() => {
                            inputSearch.current.value = ''
                            setState(prev => ({ ...prev, search: '' }))

                        }}
                    >
                        <img src="./images/cancel.svg" title="Xóa" className="img-fluid" width={24} alt='' />
                    </a>
                    <button type="button" className="btn-search">
                        <img src="./images/search.svg" title="Tìm kiếm" className="img-fluid" width={24} />
                    </button>
                </form>
                <div className="w-50 ml-3 d-flex align-items-center">
                    <Form.Label className='m-0 mr-1 mb-2'><b>Phân loại</b></Form.Label>
                    <Form.Control onChange={(e) => {
                        const value = e.target.value as IType
                        setProductType(value)
                    }} name='filter' as="select" value={productType} custom>
                        <option value='all'>Tất cả</option>
                        <option value='rx'>Thuốc kê đơn</option>
                        <option value='no_rx'>Không kê đơn</option>
                    </Form.Control>
                </div>
            </div>
            {
                <>
                    {
                        state.total === 0 &&
                        <div className="d-flex py-3 justify-content-center align-items-center">
                            <p className="m-0">Không tìm thấy sản phẩm nào</p>
                        </div>
                    }

                    <div className="row mt-2"></div>

                    {
                        state.total !== 0 &&
                        <>
                            <div ref={tableProduct} className="table-products" style={{ position: "relative", maxHeight: 'unset' }}>
                                <table className="table table-striped" style={{
                                    overflowX: 'auto'
                                }}>
                                    <thead>
                                        <tr style={{
                                            textAlign: 'start'
                                        }}>
                                            <th style={{ 
                                                maxWidth: 120,
                                                wordWrap: 'break-word',
                                                whiteSpace: 'normal',
                                            }}>ID Sản phẩm</th>
                                            <th style={{
                                                minWidth: 200,
                                                left: 120,
                                            }}>Tên sản phẩm</th>
                                            <th style={{ 
                                                width: 50,
                                            }}>Đóng gói</th>
                                            {state.listProduct?.length > 0 &&
                                                Object.keys(state.listProduct[0])
                                                    .filter((key) => key !== 'm_product_id' && key !== 'm_product_name' && key !== 'm_pkg_name')
                                                    .map((pharmacy) => <th key={pharmacy}>{pharmacy}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            state.listProduct?.map((product: any) => {
                                                return <tr key={product?.m_product_id}>
                                                    <td style={{ 
                                                        maxWidth: 120,
                                                        wordWrap: 'break-word',
                                                        whiteSpace: 'normal',
                                                    }}>{product?.m_product_id}</td>
                                                    <td style={{
                                                        textAlign: 'start',
                                                    }}>{product?.m_product_name}</td>
                                                    <td style={{ 
                                                        width: 50, 
                                                        fontWeight: 700,
                                                    }}>
                                                        {product?.m_pkg_name}
                                                    </td>
                                                    {Object.keys(product)
                                                        .filter((key) => key !== 'm_product_id' && key !== 'm_product_name' && key !== 'm_pkg_name')
                                                        .map((pharmacy) => (
                                                        <td key={pharmacy} style={{ minWidth: 80 }}>{formatPrice(product[pharmacy]) || ''}</td>
                                                        ))}
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                                {
                                    getStatisticsPriceAsync.status == "loading" &&
                                    <div className="wrap-loading">
                                        <Loading />
                                    </div>
                                }
                            </div>
                            <div className="d-flex align-items-center justify-content-start my-3 px-3">
                                <div className="pagination mt-3">
                                    {
                                        state.total &&
                                        <ReactPaginate
                                            pageClassName='page-item'
                                            breakLabel="..."
                                            onPageChange={(page: any) => {
                                                setState(prev => ({ ...prev, offset: state.limit * page.selected }))
                                            }}
                                            pageCount={Math.ceil(state.total / state.limit)}
                                            pageRangeDisplayed={1}
                                            marginPagesDisplayed={1}
                                            previousLabel={<b className="pagination-navigator">{'<'}</b>}
                                            nextLabel={<b className="pagination-navigator"> {'>'} </b>}
                                            forcePage={(state.offset) / state.limit}
                                        />
                                    }
                                </div>
                                <Form.Control
                                    className="select-page-limit"
                                    onChange={(e) => {
                                        const value = e.target.value
                                        setState(prev => ({
                                            ...prev,
                                            limit: +value,
                                        }))
                                    }
                                    }
                                    name='limit'
                                    as="select"
                                    value={state.limit}
                                    custom
                                >
                                    <option value="5">5</option>
                                    <option value='10'>10</option>
                                    <option value='20'>20</option>
                                    <option value='50'>50</option>
                                    <option value='100'>100</option>
                                </Form.Control>
                            </div>
                            <div className="d-flex align-items-center justify-content-end mb-4">
                                <div className="d-flex align-items-center justify-content-end mr-3"
                                    style={{ width: '60%' }}
                                >
                                    <b>Tổng số {state.total} sản phẩm</b>
                                </div>
                                <div className="d-flex align-items-center mr-3 justify-content-end"
                                    style={{ width: '40%' }}>
                                    <Form.Control type="number" className="mr-2" placeholder="Đến trang"
                                        ref={page}
                                        min={1}
                                        style={{ width: '68%', height: '30px' }} />
                                    <Form.Control
                                        as="button"
                                        onClick={() => {
                                            if (page.current.value > 0 && state.total && page.current.value <= Math.ceil(state.total / state.limit)) {
                                                setState(prev => ({ ...prev, offset: state.limit * (page.current.value - 1) }))
                                            }
                                        }}
                                        style={{ width: '40px', height: '30px', color: '#fff', backgroundColor: '#36cd7a', border: 'none' }}
                                    >Đi</Form.Control>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </div>
    </>
})

export default StatisticsPharmacies;